import { useTranslation } from 'react-i18next';
import ConversionDialog from 'components/Modals/ConversionDialog';
import { ProgressBar } from './styled';

interface RenderingDialogProps {
  isOpen: boolean;
}

const RenderingModal = ({ isOpen: open }: RenderingDialogProps) => {
  const { t } = useTranslation();

  return (
    <ConversionDialog
      title={t('remixer:exportingModal:rendering:title')}
      state={{
        isOpen: open,
        error: null,
        isLoading: false,
      }}
      action={{
        onSubmit: () => null,
        onClose: () => null,
        onExited: () => null,
      }}
      description={t('remixer:exportingModal:rendering:subtitle')}
      progressBar={<ProgressBar color="secondary" />}
    />
  );
};

export default RenderingModal;
